export const SUBSCRIPTIONS = '/settings/subscriptions';

export const CHECKOUT = '/checkout';

export const PAYMENT_DETAILS = '/settings/payment-details';

export const INVOICE_DETAILS_EDIT = '/settings/invoices?edit=true';
